const deleteAccountStyles = {
  dialogPaper: {
    borderRadius: "12px",
    maxWidth: "556px",
  },
  dialogTitle: {
    fontWeight: 600,
    fontSize: "18px",
    color: "rgba(183, 72, 74, 1)",
    py: "20px",
  },
  closeIconButton: {
    position: "absolute",
    right: 12,
    top: 16,
  },
  helpIconBox: {
    position: "absolute",
    right: 56,
    top: 25,
    display: "flex",
    cursor: "pointer",
  },
  dialogContent: {
    pt: "32px !important",
    pb: "0px !important",
    mb: "24px",
    borderTop: "1px solid rgba(234, 234, 234, 1)",
    overflow: "hidden",
    display: "flex",
  },
  contentScrollBox: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    gap: "32px",
    overflow: "auto",
    "&::-webkit-scrollbar": {
      width: "5px",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "rgba(159, 159, 166, 1)",
      borderRadius: "8px",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "transparent",
    },
  },
  confirmText: {
    fontSize: "18px",
    fontWeight: 500,
  },
  warningText: {
    fontSize: "15px",
    fontWeight: 400,
    mt: "16px",
  },
  warningBox: {
    backgroundColor: "rgba(183, 72, 74, 0.16)",
    p: "12px",
    borderRadius: "12px",
  },
  warningTitle: {
    fontSize: "18px",
    fontWeight: 500,
  },
  warningPoint: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    mt: "4px",
  },
  dialogActions: {
    px: "24px",
    py: "12px",
    justifyContent: "space-between",
    flexDirection: { xs: "column", sm: "row" },
    alignItems: { xs: "flex-start", sm: "center" },
    gap: "8px",
  },
  deleteButton: {
    textTransform: "none",
    color: "rgba(255, 255, 255, 1)",
    width: { xs: "100%", sm: "auto" },
    fontWeight: 500,
    fontSize: "15px",
    borderRadius: "8px",
    px: "16px",
    py: "6px",
    marginRight: "0px !important",
    marginLeft: "0px !important",
    backgroundColor: "rgba(183, 72, 74, 1)",
    borderColor: "rgba(183, 72, 74, 1)",
    boxShadow: "none !important",
    "&:hover": {
      backgroundColor: "rgba(183, 72, 74, 0.9)",
    },
    "&.Mui-disabled": {
      backgroundColor: "rgba(183, 72, 74, 0.4)",
      color: "rgba(255, 255, 255, 0.7)",
    },
  },
  loader: {
    color: "rgba(255, 255, 255, 1)",
    ml: "8px",
  },
};

export default deleteAccountStyles;
